<template>
  <v-container fluid>
    <v-flex xs12 class="text-center justify-center mb-4 mt-6">
      <h4 class="font-weight-bold">ESTADO USUARIOS</h4>
    </v-flex>
    <v-card>
      <v-card-text>
        <filtros
          ref="criterios"
          :campos.sync="camposfiltros"
          @actualizarFiltro="buscarCuando"
          @nuevo="addUpdate"
        ></filtros>
      </v-card-text>
    </v-card>
    <v-data-table
      :headers="headers"
      :items="desserts"
      :options.sync="options"
      :server-items-length="totalItems"
      :loading="loading"
      class="elevation-1"
      no-data-text="Datos no disponibles"
      no-results-text="Cargando..."
      :dense="true"
      fixed-header
      :height="500"
      :footer-props="{
        'items-per-page-options': [5, 10, 20, 50, 100, 500],
      }"
      :disable-sort="true"
    >
      <template v-slot:top>
        <v-toolbar flat></v-toolbar>
      </template>
      <template v-slot:[`item.login`]="{ item }">
        <v-badge dot right inline :color="item.login ? 'success' : 'warning'">
          {{ item.login ? "Logueo" : "Deslogueo" }}
        </v-badge>
      </template>
      <template v-slot:[`item.duracion_sesion`]="{ item }">
        {{ item.duracion_sesion ? item.duracion_sesion : 15 }} min
      </template>
      <template v-slot:[`item.disponibilidad`]="{ item }">
        <v-badge
          dot
          inline
          :color="
            item.disponibilidad
              ? estadoUsuario.find((el) => el.value === item.disponibilidad)
                  .color
              : 'red'
          "
        >
          {{
            item.disponibilidad
              ? item.disponibilidad
              : "Fuera de su horario laboral"
          }}
        </v-badge>
      </template>
      <template v-slot:[`item.action`]="{ item }">
        <v-btn
          color="primary"
          icon
          outlined
          small
          @click="updateEstado(item)"
          title="Update Estado"
        >
          <v-icon>mdi-account-circle</v-icon>
        </v-btn>
        <v-btn
          color="primary"
          icon
          outlined
          small
          @click="tiempoLogin(item)"
          title="Tiempo por sesión"
        >
          <v-icon>mdi-timer</v-icon>
        </v-btn>
        <v-btn
          color="primary"
          icon
          outlined
          small
          @click="estadoLogin(item)"
          title="Estado login"
        >
          <v-icon>mdi-power</v-icon>
        </v-btn>
        <v-btn
          v-if="logueado.cargo == 'Administrador'"
          color="primary"
          icon
          outlined
          small
          @click="cambioClave(item)"
          title="Actualizar Contraseña"
        >
          <v-icon>mdi-key</v-icon>
        </v-btn>
        <!-- <v-btn
          color="primary"
          icon
          outlined
          small
          @click="dashboard(item)"
          title="Update Estado"
        >
          <v-icon small>mdi-chart-histogram</v-icon>
        </v-btn> -->
      </template>
    </v-data-table>
    <modal-estado
      v-if="showModalEstado"
      :showModal.sync="showModalEstado"
      :id="id"
      @actualizar="getData"
    ></modal-estado>
    <modal-estado-login
      v-if="showModalEstadoLogin"
      :showModal.sync="showModalEstadoLogin"
      :id="id"
      @actualizar="getData"
    ></modal-estado-login>
    <modal-tiempo-login
      v-if="showModalTiempoLogin"
      :showModal.sync="showModalTiempoLogin"
      :id="id"
      @actualizar="getData"
    ></modal-tiempo-login>
    <modal-clave
      v-if="showModalClave"
      :showModal.sync="showModalClave"
      :id="id"
      @actualizar="getData"
    ></modal-clave>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import { db } from "../../firebase";
import moment from "moment";
import Paginado from "../../helpers/Paginado";
import Filtros from "../General/Filtros.vue";
import ModalEstado from "./ModalEstado.vue";
import ModalEstadoLogin from "./ModalEstadoLogin.vue";
import ModalTiempoLogin from "./ModalTiempoLogin.vue";
import ModalClave from "./ModalClave.vue";

export default {
  components: {
    Filtros,
    ModalEstado,
    ModalEstadoLogin,
    ModalTiempoLogin,
    ModalClave,
  },
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Estado",
  data() {
    return {
      coleccion: "usuarios",
      consulta: [""],
      condicion: "in",
      campo: "cargo",
      totalItems: 0,
      lastVisible: "",
      itemsPerPage: 0,
      ordenar: "",
      typoOrdenar: false,
      page: 0,
      options: {},
      camposfiltros: [],
      campoFiltro: "",
      operadorFiltro: "",
      valorFiltro: "",
      criterios: [],
      search: "",
      loading: true,
      desserts: [],
      headers: [
        { text: "Estado Logueo", value: "login" },
        { text: "Nombres", value: "nombres" },
        { text: "Apellidos", value: "apellidos" },
        { text: "Identificación", value: "identificacion" },
        { text: "Email", value: "email" },
        { text: "Teléfono", value: "telefono" },
        { text: "Cargo", value: "cargo" },
        { text: "Estado disponibilidad", value: "disponibilidad" },
        { text: "Tiempo Login", value: "duracion_sesion" },
        { text: "Acciones", value: "action" },
      ],
      showModalEstado: false,
      showModalEstadoLogin: false,
      showModalTiempoLogin: false,
      showModalClave: false,
      condicionDatos: {},
    };
  },
  computed: {
    ...mapState(["logueado", "estadoUsuario"]),
    autorizaCrear() {
      return false;
    },
  },
  async mounted() {
    this.headers.forEach((element) => {
      if (
        element.value !== "duracion_sesion" &&
        element.value !== "action" &&
        element.value !== "disponibilidad"
      ) {
        this.camposfiltros.push({
          campo: element.value,
          etiqueta: element.text,
        });
      }
    });
  },
  watch: {
    options: {
      handler() {
        this.getData();
      },
      deep: true,
    },
  },
  created() {
    if (this.logueado.cargo == "Administrador") {
      this.consulta = [
        "Call Center",
        "Investigador",
        "Abogado",
        "Perito",
        "Coordinador Contact Center",
        "Coordinador Investigador",
        "Coordinador Abogado",
        "Coordinador Perito",
        "Administrador",
        "Dibujante",
      ];
    }
    if (this.logueado.cargo == "Coordinador Contact Center") {
      this.consulta = ["Call Center"];
    }
    if (this.logueado.cargo == "Coordinador Investigador") {
      this.consulta = ["Investigador", "Dibujante"];
    }
    if (this.logueado.cargo == "Coordinador Abogado") {
      this.consulta = ["Abogado"];
    }
    if (this.logueado.cargo == "Coordinador Abogado CAIT") {
      this.consulta = ["Abogado CAIT"];
    }
    if (this.logueado.cargo == "Coordinador Perito") {
      this.consulta = ["Perito"];
    }
  },
  methods: {
    async getData() {
      try {
        const { itemsPerPage, page, sortDesc } = this.options;
        this.itemsPerPage = itemsPerPage;
        this.page = page;
        if (this.valorFiltro) {
          this.buscarCuando();
          return;
        }
        this.typoOrdenar = sortDesc[0] ? "asc" : "desc";
        this.condicionDatos = {
          campo: this.campo,
          operador: this.condicion,
          valor: this.consulta,
        };
        const paginado = new Paginado(
          db,
          this.coleccion,
          this.campo,
          this.itemsPerPage,
          page,
          this.condicionDatos
        );
        const { registros, total } = await paginado.data();
        this.desserts = registros;
        this.totalItems = total;
        this.loading = false;
      } catch (err) {
        this.handleError(err);
      }
    },
    async buscarCuando() {
      try {
        this.criterios = await this.$refs.criterios.enviarCriterios();
        if (this.criterios.length > 0 && this.criterios[0].valor) {
          this.criterios.forEach((element) => {
            if (element.campo && element.valor) {
              console.log(element.campo);
              console.log(element.valor);
              this.campoFiltro = element.campo;
              this.operadorFiltro = element.operador;
              this.valorFiltro = element.valor.toUpperCase().trim();
              if (element.campo == "email" || element.campo == "cargo")
                this.valorFiltro = element.valor;
              if (element.campo == "login")
                this.valorFiltro = element.valor == "Logueo" ? true : false;
            }
          });
          db.collection(this.coleccion)
            .where(this.campoFiltro, this.operadorFiltro, this.valorFiltro)
            .where(this.campo, this.condicion, this.consulta)
            .limit(this.itemsPerPage * this.page)
            .get()
            .then((resul) => {
              this.lastVisible = resul.docs[resul.docs.length - 1] || null;
              this.firstVisible = resul.docs[0] || null;
              const res = resul.docs.map((doc) => ({
                id: doc.id,
                ...doc.data(),
                creado: moment(doc.data().creado).format("YYYY-MM-DD hh:mm:ss"),
              }));
              this.desserts = res;
            });
        }
      } catch (error) {
        this.handleError(error);
      }
    },
    addUpdate(item = "") {
      if (!this.autorizaCrear) {
        this.$swal({
          icon: "info",
          title: "Oops...",
          text: "Usuario no autorizado",
        });
        return;
      }
      this.id = item.id;
      this.showModal = true;
    },
    async dashboard(item) {
      console.log(item);
      this.$router.push(`/estadistica/${item.id}`);
    },
    updateEstado(item) {
      this.id = item.id;
      this.showModalEstado = true;
    },
    tiempoLogin(item) {
      this.id = item.id;
      this.showModalTiempoLogin = true;
    },
    estadoLogin(item) {
      this.id = item.id;
      this.showModalEstadoLogin = true;
    },
    cambioClave(item) {
      this.id = item.uiid;
      this.showModalClave = true;
    },
    handleError({ message }) {
      this.$swal({ icon: "error", title: "Oops...", text: message });
      this.loading = false;
    },
  },
};
</script>

<style src="./Usuarios.scss" lang="scss"></style>
